import {sleep} from "nate-react-api-helpers";

const transientStatuses = [502, 503, 504];

// true for failures caused by the backend being unreachable or restarting (gateway errors, network errors).
// Errors returned by the backend itself (e.g. 400/500 with a json error body) are not transient.
export function isTransientError(e: any): boolean {
    if (e instanceof TypeError) return true; // fetch network failure

    const status = e?.info?.response?.status ?? e?.info?.xhr?.status;
    return transientStatuses.includes(status);
}

// retries callback on transient errors, waiting delaysMs[i] before retry i
export async function retryTransient<T>(callback: () => Promise<T>, delaysMs: number[] = [500, 1000, 1500, 2000, 2000, 2500, 2500, 3000]): Promise<T> {
    for (let i = 0; ; i++) {
        try {
            return await callback();
        } catch (e) {
            if (i >= delaysMs.length || !isTransientError(e)) throw e;
            await sleep(delaysMs[i]);
        }
    }
}
